<template>
    <div v-if="cargando">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
            </div>
        </div>
    </div>
    <div v-else>
    <b-container fluid>
    <b-row>     
        <b-col md="2">
            <b-form-group horizontal label="Orden" class="mb-0">
                <b-input-group>
                <b-form-select v-model="orden" slot="append" @input="listComprobantes">
                    <option :value="'asc'">Más Antiguo</option>
                    <option :value="'desc'">Más Reciente</option>
                </b-form-select>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col md="8">
            <div class="col-md-12 text-center">
                <b-button variant="secondary" @click="listComprobantes"><i class="fa fa-refresh"></i> </b-button>
            </div>
        </b-col>
        <b-col md="2">
            <b-form-group horizontal label="Mostrar" class="mb-0">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listComprobantes">
                    <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>
                </b-input-group>
            </b-form-group>
        </b-col>
    </b-row>
    <br>
        <br>
        <b-table responsive 
            :small="small"
            :outlined="outlined"
            :striped="striped"
            :items="comprobantes"
            :fields="comprobantes_fields"
            :current-page="pactual"
            :per-page="limite"            
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            >
            <template slot="estado" slot-scope="data">
                <div class="text-center">
                    <template v-if="data.item.emitido==1 && data.item.baja==1">
                        <div><span class="badge badge-info">Baja <i class="fa fa-ban"></i></span></div>
                    </template>
                    <template v-else>
                        <div v-if="data.item.emitido==1"><span class="badge badge-success">Emitido <i class="fa fa-check"></i></span></div>
                        <div v-else-if="data.item.emitido==0"><span class="badge badge-warning">Procesando <i class="fa fa-spin fa-spinner"></i></span></div>
                        <div v-else-if="data.item.emitido==2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"></i></span></div>
                    </template>
                </div>
            </template>
            <template slot="receptor" slot-scope="data">
                <template v-if="data.item.receiver">
                    {{data.item.idReceptor}} - {{data.item.receiver.razonSocial}}
                </template>
                <template v-else>
                    <template v-if="data.item.idReceptor=='-'">
                        P&uacute;blico en General
                    </template>
                    <template v-else>
                        {{ data.item.idReceptor }}
                    </template>
                </template>
            </template>
            <template slot="emision" slot-scope="data">
                {{ data.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }}
            </template>
            <template slot="moneda" slot-scope="data">
                <div class="text-right">
                    <template v-if="data.item.tipoMoneda=='PEN'">S/</template>
                    <template v-else-if="data.item.tipoMoneda=='USD'">$</template>
                    <template v-else>{{ data.item.tipoMoneda }}</template>
                    {{data.item.importeTotal}}
                </div>
            </template>
            <template slot="acciones" slot-scope="data">
                <template v-if="data.item.emitido!=2 && data.item.baja!=1">
                <b-button-group>
                    <b-button v-b-modal.prevmodal v-b-tooltip.hover title="Vista Previa" @click="viewPdf(data.item)"><i class="fa fa-television"></i></b-button>
                    <b-button @click="downloadPdf(data.item)" v-b-tooltip.hover title="Descargar PDF"><i class="fa fa-file-pdf-o"></i></b-button>
                    <b-button @click="setTicket(data.item)" v-b-modal.sendboletaemail1 v-b-tooltip.hover title="Enviar por Mail"><i class="fa fa-envelope-o"></i></b-button>
                    <b-button v-if="data.item.emitido==0" title="Descargar CDR" class="disabled" :disabled="true"><i class="fa fa-file-zip-o"></i></b-button>
                    <b-button v-else @click="downloadCdr(data.item)" title="Descargar CDR"><i class="fa fa-file-zip-o"></i></b-button>
                    <b-button @click="downloadXml(data.item)" v-b-tooltip.hover title="Descargar XML"><i class="fa fa-file-code-o"></i></b-button>
                </b-button-group>
                </template>
                <template v-else>
                    <b-button-group>
                        <b-button @click="downloadCdr(data.item)" title="Descargar CDR"><i class="fa fa-file-zip-o"></i></b-button>
                    </b-button-group>
                </template>
            </template>
        </b-table>
        </b-container>
    <b-modal id="sendboletaemail1" title="Enviar por Correo" v-model="previacorreo">
        <div role="group">
        <label for="inputLive">Correos:</label>
        <b-form-input v-model="recipients" type="email" @keyup.enter="sendMail(ticket)"></b-form-input>
        <p class="input-requerido">Ingresa un correo ó varios separados por comas (,)</p>
        </div>
            <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="sendMail(ticket)">
            Enviar
            </b-btn>
            <b-btn v-else size="sm" class="float-right" variant="secondary">
            <i class="fa fa-spin fa-spinner"></i> Enviando...
            </b-btn>
        </div>
    </b-modal>
        <b-modal id="prevmodal" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previaboleta">
        <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
        <template v-else>
            <template v-if="pdfobject !==''">
            <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
        </template>
    </b-modal>
    <div class="row">
        <div class="col-md-6">
            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
        </div>
        <div class="col-md-6">
            <div class="float-right">
                <b-pagination size="sm" :total-rows="total" v-model="currentPage" @input="listComprobantes" :per-page="limite"></b-pagination>
            </div>            
        </div>
    </div>
    <vue-snotify></vue-snotify>
</div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
export default {
    name: 'ComunicacionBajaConsulta',
    data: () => {
        return {
            striped: true,
            outlined: true,
            small: true,
            filter: null,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            currentPage: 1,
            totalRows: null,
            previaboleta: false,
            previacorreo: false,
            sendcorreo: false,
            comprobantes: [],
            bajas: [],
            ticket: {},
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            cargando: false,
            pactual: 1,
            orden: 'desc',
            limite: 10,
            comprobantes_fields: [
                {key: 'serie', label: 'Serie', sortable: true},
                {key: 'numero', label: 'Numero', sortable: true},
                {key: 'emision', label: 'Emisión', sortable: true},
                {key: 'receptor', label: 'Receptor', sortable: true},
                {key: 'moneda', label: 'Importe Total', sortable: true},
                {key: 'estado', label: 'Estado', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            pdfobject: '',
            cargandopdf2: false,
            recipients: '',
            serie: '',
            numero: ''
        }
    },
    mounted () {
        this.listComprobantes()
    },
    methods: {        
        listComprobantes: function () {
            this.cargando = true
            axios
            .post(process.env.VUE_APP_API_URL + 'comunicacionbaja', {
                token: this.$store.getters.userToken,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden
            })
            .then(response => (
                this.comprobantes = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false
                ))
            .catch(error => {
                this.cargando = false
            })
        },
        setTicket: function (data) {
            this.ticket = data
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true,
            this.previaboleta = true,
            axios
           .post(process.env.VUE_APP_API_URL + 'boletas/pdf',{
               token: this.$store.getters.userToken,
               id: data.idBoleta
           })
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
            .catch(error => (
                this.previaboleta = false,
                this.cargandopdf2 = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        sendMail: function (data) {
            this.previacorreo = true,
            this.sendcorreo = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'boletas/mail', {
                token: this.$store.getters.userToken,
                id: data.idBoleta,
                mail: this.recipients
            })
            .then(response => (
               this.sendcorreo = false,
               this.previacorreo = false,
               this.$snotify.success(response.data.message, 'Exito')
                ))
             .catch(error => (
                this.previacorreo = false,
                this.previacorreo = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        downloadPdf: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = data.serie + '-' + data.numero + '.pdf'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandopdf = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'boletas/pdf',{
               token: this.$store.getters.userToken,
               id: data.idBoleta
           })
           .then(response => (
               file = 'data:application/pdf;base64,'+ response.data.base64,
               this.cargandopdf = false,
               download(file, name,'application/pdf'),
               this.$swal.close()
           ))
            .catch(error => (
                this.$swal.close(),
                this.$snotify.error(error.response.data.response, 'Error'),
                this.cargandopdf = false
            ))
        },
        downloadCdr: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandocdr = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'boletas/constancia',{
               token: this.$store.getters.userToken,
               id: data.idBoleta
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.msg.xml,
               this.cargandocdr = false,
               download(file, name,'application/zip'),
               this.$swal.close()
           ))
           .catch(function (error){

           })
        },
        downloadXml: function (data){
            let name = data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/zip;base64,'+ data.xml
            download(file, name,'application/zip');
        },
    }
}
</script>
